import type { BaseIssue } from '@momentum/types';
import { IssueStatus } from '@momentum/types';

/**
 * Checks if a goal or task is overdue
 * A goal/task is considered overdue if:
 * - It has a dueDate
 * - The dueDate is in the past (compared to current date)
 * - The status is not COMPLETED
 */
export const isOverdue = (
  issue: Pick<BaseIssue, 'status' | 'dueDate'>
): boolean => {
  if (!issue.dueDate) {
    return false;
  }

  if (issue.status === IssueStatus.COMPLETED) {
    return false;
  }

  const dueDate = new Date(issue.dueDate);
  const today = new Date();
  // Reset time to start of day for accurate date comparison
  today.setHours(0, 0, 0, 0);
  dueDate.setHours(0, 0, 0, 0);

  return dueDate < today;
};
